export const JWT_SECRET = 'jwt-super-long-secret-prosper-shine';
export const JWT_EXPIRES_IN = 48;

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY
};

export const mapConfig = process.env.REACT_APP_MAP_MAPBOX;

export const googleAnalyticsConfig = process.env.REACT_APP_GA_MEASUREMENT_ID;
